<!-- 拖拽签署块 -->
<template>
<div
    class="drag-stamper"
    ref="Rect"
    @click.stop.prevent
    @mousedown.stop="stamperDrag($event, stamper, index)"
    :class="{
        'active': !this.isAssignation,
        'red-active': this.isAssignation,
    }"
    :style="stamper.style">
    <i v-if="!isAssignation" @click="deleteCover" class="delete-icon el-icon-error" :class="{'across': isAcross }"></i>
    <div v-if="isAcross" style="overflow: hidden;height:100%">
        <img slot="reference" class="is-across" :src="imageSrc" ondragstart="return false;" alt="" height="100%">
    </div>
    <img slot="reference" v-else-if="imageSrc && stamper.rectType !== 'TIMESTAMP'" :src="imageSrc" ondragstart="return false;" alt="" height="100%">
    <template v-else-if="imageSrc && stamper.rectType === 'TIMESTAMP'">
        <div 
            class="appoint-time-rect"
            @click="handleClickStatus(stamper)"
            v-click-outside="(e) => handleClickOutside(e, stamper)"
        >
            <div
                v-if="stamper.isClicked"
                :style="blockToolStyle()"
            >
                <block-tool-time :block="stamper"/>
            </div>
            <img
                :src="imageSrc"
                alt=""
            >
        </div>
    </template>
    <button class="sign-button"
        v-if="stamper.active && stamper.rectType !== 'ACROSS_PAGE'"
        @dragstart.stop
        @mousedown.stop
        @click.stop="signPage.doConfirmSign()">完成签署</button>
</div>
</template>

<script>
import blockToolTime from './block-tool-time.vue';
import ToolBarStyle from '../utils/block-style';

const wrapperClassName = 'pdf-scroll-page';

export default {
    components: { blockToolTime },
    props: {
        //签章块数据
        stamper: {
            type: Object,
            default () {
                return {}
            }
        },
        signStampers: {
            type: Array,
            default () {
                return []
            }
        },
        index: Number,
        page: {
            type: Object,
            default () {
                return {}
            }
        },
        originPointer: {
            type: String,
            default: 'LB'
        },
    },
    inject: ['signPage'],
    computed: {
        imageSrc () {
            return this.stamper.src;
        },
        isAcross () {
            return ['ACROSS_PAGE', 'ACROSS_PAGE_ODD'].includes(this.stamper.rectType);
        },
        isAssignation() {
            return this.stamper.isAssignation;
        },
        isOriginLB() {
            return this.originPointer === 'LB';
        },
    },
    methods: {
        //工具栏样式
        blockToolStyle () {
            return new ToolBarStyle();
        },
        // 展示同步签署块的弹窗
        showSignMultiPageDialog(stamper) {
            this.$emit('showSignMultiPageDialog', stamper);
        },
        //删除拖拽块
        deleteCover() {
            this.$nextTick(() => {
                this.$emit('deleteCover', this.index);
            })
        },
        // 移动签名块
        stamperDrag(e, stamper, stamperIndex) {
            if (this.isAssignation) {
                return;
            }

            //拖章逻辑
            const style = this.stamper.style;
            const wrapper =  this.Utils.getParentByClass(this.$refs.Rect, wrapperClassName);
            const documentWidth = wrapper && wrapper.offsetWidth;
            const documentHeight = wrapper && wrapper.offsetHeight;

            const stamperSpec = {
                width: parseFloat(style.width) * documentWidth / 100,
                height: parseFloat(style.height) * documentHeight / 100,
            }

            let left, top;
            let offset;
            const pageNode  = this.Utils.getParentByClass(e.target, 'pdf-scroll-page');

            document.onmousemove = e => {
                const pagePos = pageNode.getBoundingClientRect();

                // 鼠标位置相对于签章框的距离
                if (!offset) {
                    const stamWrapper = this.Utils.getParentByClass(e.target, 'drag-stamper');
                    const stamPos  = stamWrapper && stamWrapper.getBoundingClientRect();
                    (offset = {}).offsetX = e.clientX - stamPos.left;
                    offset.offsetY = e.clientY - stamPos.top;
                }

                // 签章位置 = 当前鼠标位置 - 当前文件页元素偏移位置 - 鼠标位置相对于签章框的距离
                left = e.clientX - pagePos.left - offset.offsetX;
                top = e.clientY - pagePos.top - offset.offsetY;

                // 边界判断
                // 拖动边界
                if (left < 0) {
                    left = 0;
                }
                //第一页或者同步多页面限制边界
                if (top < 0) {
                    top = 0;
                }
                if (left + stamperSpec.width > documentWidth) {
                    left = documentWidth - stamperSpec.width;
                }
                //最后一页或者同步多页面限制边界
                if (top + stamperSpec.height > documentHeight) {
                    top = documentHeight - stamperSpec.height;
                }
                // origin pointer is left bottom
                // origin pointer is left top
                this.isOriginLB ?
                    (this.stamper.offsetY = (1 - (top + stamperSpec.height) / documentHeight ))
                  : (this.stamper.offsetY = top / documentHeight);

                !this.isAcross && (this.stamper.offsetX = left / documentWidth);

                // origin pointer is left bottom
                // origin pointer is left top
                this.isOriginLB ?
                    (this.stamper.style.top =  (top / documentHeight * 100) + '%')
                  : (this.stamper.style.top =  (this.stamper.offsetY * 100) + '%');

                !this.isAcross && (this.stamper.style.left =  (this.stamper.offsetX * 100) + '%');
            };
            document.onmouseup = e => {
                document.onmousemove = null;
                document.onmouseup = null;
            }
        },
        handleClickStatus(stamper) {
            this.$emit('resetStamperAndRectangles');
            this.$set(stamper, 'isClicked', true);
        },
        handleClickOutside(e, stamper) {
            this.$set(stamper, 'isClicked', false);
        },
    },
}
</script>

<style lang="less" scoped>
.drag-stamper {
    position: absolute;
    text-align: center;
    border-radius: 2px;
    border: 1px dashed #efefef;
    &:hover {
        border: 1px dashed @blue;
    }
    .item {
        display: inline-block;
        width: 100%;
        height: 100%;
    }
    &.active {
        border: 1px solid @blue;
        background: rgba(0, 160, 233, 0.1);
    }
    &.red-active {
        border: 1px solid @red;
        background: rgba(255, 11, 33, 0.1);
    }
    &.positive {
        border: 1px solid red;
    }
    .seal-img {
        cursor: move;
        max-height: 100%;
        max-width: 100%;
    }
    .is-across {
        object-fit: cover;
        object-position: left;
    }
    .appoint-time-rect {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

}
.delete-icon {
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 20px;
    color: #C1C6CD;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
    z-index: 10;
    &.across {
        left: -10px;
        right: auto;
    }
}
    .sign-button {
        position: absolute;
        bottom: -33px;
        right: -75px;
        display: inline-block;
        padding: 8px 12px;
        background: @primary;
        color: @white;
        border: none;
        border-radius: 3px;
        outline: none;
    }
</style>

<style lang="less">
.stamper-enterprise-popper {
    z-index: 10!important;
    border:1px solid rgba(217,217,217);
    min-width: 106px!important;
    width: 106px!important;
    padding: 0;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.13);
    /deep/ .popper__arrow{
        display: none;
    }
}

</style>